import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { filterAutocomplete_template } from "./filterAutocomplete_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import { tagTypFieldEdit_template } from "./tagTypFieldEdit_template";
import { field } from "../../modules/field";

declare var ko: any;

export class tagStore_template extends vnTemplate {

    public tagTypeFilter: filterAutocomplete_template;
    public tagTypeFieldEdit: tagTypFieldEdit_template;
    public pagination: pagination_template;

    public validationsList: validationsList_template;

    protected getTemplateHtml(): string {

        return /*html*/ `
        <div class="w-lightbox w-picker" data-bind="css: { 'is-visible' : isVisible }">
            <div class="lightbox-content picker" >

                <div class="picker-header  w-justify">
                    <div class="w-left">
                    </div>
                    <div class="w-center">
                        <span class="picker-header-title icon i-tag">Tag Activation</span>
                    </div>
                    <div class="w-right">
                        <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
                    </div>
                </div>
                ${this.validationsList.getHtmlBuild()}
                <div class="picker-body" data-bind="css: { 'loading': isLoadingActivate}, style: { gridAutoRows : 'auto'}">
                    <div class="tag-tool-header list-header w-justify" data-bind="style: { alignItems : 'flex-start'}" style="padding: 1.5rem ;">
                        <div class="w-left" data-bind="style: { alignItems : 'flex-start'}">
                            <div class="tag-input">
                                <input type="text" class="input-text w-autocomplete" placeholder="Tag Name" data-bind="textInput: tagName" />
                                <div class="form-group border" style="margin-left:1.2rem">
                                    <!-- ko if: selectedTagTypeOptionalReferenceFields().length > 0 -->
                                    <span class="form-label">Reference Fields</span>
                                    <!-- /ko -->
                                    <div data-bind="foreach: selectedTagTypeOptionalReferenceFields, style: { marginLeft : '1rem'}">
                                        <div>
                                            <span class="form-label" data-bind="text: field.label + ': '"></span>
                                            <span class="info type" data-bind="text: value"></span>
                                            <button type="button" class="btn-txt icon i-edit" data-bind="event: { click: $parent.onClickEditOptionalReferenceField }"></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tag-input">
                                ${this.tagTypeFilter.getHtmlBuild()}
                            </div>
                        </div>
                        <div class="w-center" data-bind="style: { alignItems : 'baseline'}">
                        </div>
                        <div class="w-right" data-bind="style: { alignItems : 'baseline'}">
                            <div>
                                <button data-bind="style: {opacity: isConfirmTagButtonEnabled() ? 1 : .5}, enable: isConfirmTagButtonEnabled, event: { click: onClickActivateTag }" class="w-autocomplete btn icon i-add" type="button">Confirm</button>
                            </div>
                        </div>
                </div>
                <!-- ko if: tagName -->
                        <div class="tag-suggestion-title w-form">
                            <span class="form-sub-title" data-bind="text: 'Suggested Tags'"></span>
                        </div>
                <!-- /ko -->

                <div class="w-tag-tool-results w-picker-list" id="tag-store-results-list" data-bind="css: { 'loading': isLoadingResults }" >
                    <ul class="picker-list" data-bind="foreach: tags">
                    <!-- ko if: isActive -->
                        <li class="picker-item icon" data-bind="css: { 'picker-item-active': isActive }">
                            <div class="w-info">
                               <div class="tag-name">
                                 <strong data-bind="text: name"></strong>
                               </div>

                               <div class="tag-info" style="display:flex;justify-content: space-between;width: calc(100% - 6px);">
                                    <div>
                                        <div>
                                            <!-- ko if: type -->
                                                <span class="info type" data-bind="text: type.name"></span>
                                            <!-- /ko -->

                                            <!-- ko ifnot: type -->
                                                <span class="info type"></span>
                                            <!-- /ko -->
                                        </div>
                                        <!-- ko if: type && type.dataset -->
                                        <div class="tag-dataset">
                                            <span class="info dataset" data-bind="text: '[' + type.dataset.name + ']'"></span>
                                        </div>
                                        <!-- /ko -->
                                    </div>
                                    <div>
                                        <span class="info type" style="margin-bottom: 2px;" data-bind="text: referenceDescription"></span>
                                    </div>
                               </div>

                               <div class="tag-active icon i-on-off-button"></div>
                            </div>
                        </li>
                    <!-- /ko -->
                    <!-- ko ifnot: isActive -->
                        <li class="picker-item icon" class="cursor" data-bind="click: $parent.onClickTag, class: $parent.selectedTagId() == $data.id && $parent.tagName() == $data.name ? 'picker-selected' : ''">
                            <div class="w-info">
                               <div class="tag-name">
                                  <strong data-bind="text: name"></strong>
                                  <span class="info type" data-bind="text: referenceDescription"></span>
                                </div>

                                <div class="tag-info">
                                   <div>
                                      <!-- ko if: type -->
                                      <span class="info type" data-bind="text: type.name"></span>
                                  <!-- /ko -->

                                  <!-- ko ifnot: type -->
                                    <span class="info type"></span>
                                  <!-- /ko -->
                                   </div>
                                   <!-- ko if: type && type.dataset -->
                                   <div class="tag-dataset">
                                      [<span class="info dataset" data-bind="text: type.dataset.name"></span>]
                                   </div>
                                   <!-- /ko -->
                                </div>

                            </div>
                        </li>
                    <!-- /ko -->
                    </ul>
                </div>
            </div>
            ${this.tagTypeFieldEdit.getHtmlBuild()}
        </div>
        `;
    }

    protected initPartial(): void {
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 80;

        this.tagTypeFilter = new filterAutocomplete_template("tagTypeFilter", this.getTemplateViewModel(), this.caller);
        this.tagTypeFilter.setAddNewOptionEnabled(false);
        this.tagTypeFilter.setPlaceholder('Tag Type');
        this.tagTypeFilter.setOptionType("Tag Type");
        this.tagTypeFilter.setFilterIconCSSClass('i-tag-type-a');

        this.tagTypeFieldEdit = new tagTypFieldEdit_template(
            "tagTypeFieldEdit",
            this.getTemplateViewModel(),
            this.caller
          );
          this.tagTypeFieldEdit.setBrand(this.caller.getBrandId());

        this.validationsList = new validationsList_template("validationsList", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string {

        return "tagStore_template";
    }

    protected buildViewModel(): any {

        const self = this;

        let vm = {
            isVisible: ko.observable(false),
            tagName: ko.observable(''),
            tagType: ko.observable({}),
            tags: ko.observableArray([]),
            selectedTagId: ko.observable(null),
            isLoadingActivate: ko.observable(false),
            isLoadingResults: ko.observable(false),
            tagLoadEnable: ko.observable(false),
            tagStoreNextPageRequested: ko.observable(false),
            selectedTagTypeOptionalReferenceFields: ko.observableArray([]),
            optionalReferenceFields: ko.observableArray([]),
            editedSpec: ko.observable(null),

            onClickTag: function (data, event) { self.onClickTag(data); },
            onClickActivateTag: function (data, event) { self.onClickActivateTag(); },
            onClickCancel: function (data, event) { self.onClickCancel(); },
            onClickEditOptionalReferenceField: function (data, event) { self.onClickEditOptionalReferenceField(data); },
            formattedOptionalReferenceFieldValues: function (data) { return self.formattedOptionalReferenceFieldValues(data); },

            isConfirmTagButtonEnabled: ko.pureComputed(function () {
                const tagName = self.getTemplateViewModel().tagName();
                if (tagName.trim() == '') {
                    return false;
                }
                return true
            })

        }
        vm.tagName.extend({ rateLimit: { timeout: 200, method: 'notifyWhenChangesStop' } });
        vm.tagName.subscribe((newVal) => {
            this.similarSearchTags();
        })
        vm.tagType.subscribe((newVal) => {
            this.similarSearchTags();
            vm.selectedTagTypeOptionalReferenceFields([]);

            if (newVal && newVal.optionalReferenceFields) {
                newVal.optionalReferenceFields.forEach((optionalReferenceField) => {
                    const field = newVal.fields.find(field => field.id == optionalReferenceField.idField);
                    if (field) {
                        optionalReferenceField.field = field;
                        optionalReferenceField.value = optionalReferenceField.value ? optionalReferenceField.value : null;
                        if(field.grouping) {
                            this.tagTypeFieldEdit.setGroupings([field.grouping]);
                        } else {
                            this.tagTypeFieldEdit.setGroupings([]);
                        }
                    }
                })
                vm.selectedTagTypeOptionalReferenceFields(newVal.optionalReferenceFields);
            }

            vm.selectedTagId(null);
        })
        return vm
    }

    public setCaller(caller) {
        this.caller = caller;
        this.tagTypeFilter.caller = caller;
        this.pagination.caller = caller;
        this.validationsList.caller = caller;
        this.tagTypeFieldEdit.caller = caller;
        this.tagTypeFieldEdit.tagPickerSourceFilterTagType.caller = caller;
        this.tagTypeFieldEdit.tagSourcePickerTagFilter.caller = caller;
        this.tagTypeFieldEdit.editSpecificationTooltip.caller = caller;
    }

    public getViewModelForSimilarSearch() {
        const tagType = this.getTemplateViewModel().tagType();

        return {
            pagination: this.getTemplateViewModel().pagination,
            tagName: this.getTemplateViewModel().tagName(),
            typeName: tagType ? tagType.typeName : null,
            datasetName: tagType ? tagType.datasetName : null,
        };
    }

    public getViewModelForTagActivation(idTag) {
        const tagType = this.getTemplateViewModel().tagType();

        return {
            idTag: idTag,
            tagName: this.getTemplateViewModel().tagName(),
            typeName: tagType ? tagType.typeName : null,
            datasetName: tagType ? tagType.datasetName : null,
            optionalReferenceFields: this.getTemplateViewModel().selectedTagTypeOptionalReferenceFields(),
        }
    }


    protected getIsVisible(): any {
        return this.getTemplateViewModel().isVisible;
    }

    protected setIsVisible(isVisible: boolean): void {
        this.getTemplateViewModel().isVisible(isVisible);
    }

    public setTags(tags) {
        if(this.getTemplateViewModel().pagination.pageNumber() == 1) {
            this.getTemplateViewModel().tags([]);
        }
        if(tags.length > 0) {
            let tagList = this.getTemplateViewModel().tags().concat(tags);
            this.getTemplateViewModel().tags(tagList);
            this.getTemplateViewModel().tagStoreNextPageRequested(false);
            if(!this.getTemplateViewModel().tagLoadEnable()) {
                this.enableTagStoreWaypoint();
            }
        }
    }

    public enableTagStoreWaypoint() {

        var div = document.getElementById('tag-store-results-list');
        let self = this;

        var locked = false;
        var lastCall = 0;

        if(div) {
            div.addEventListener("scroll", function (event) {
                if(locked) return;

                if (lastCall) clearTimeout(lastCall);
                lastCall = setTimeout(() => {
                    if(self) {
                        self.runOnScroll(event, lastCall, locked, self, div);
                    }
                }, 200);
                if (div && document.body.classList.contains("is-fixed") && div.scrollTop!= 0 && div.scrollTop + div.clientHeight >= (div.scrollHeight - 100) && !self.getTemplateViewModel().tagStoreNextPageRequested()) {
                    if (self.getTemplateViewModel().pagination.pageNumber() < self.getTemplateViewModel().pagination.pageMax()) {
                        self.getTemplateViewModel().pagination.pageNumber(self.getTemplateViewModel().pagination.pageNumber() + 1)
                        self.caller.similarSearchTags();
                        self.getTemplateViewModel().tagStoreNextPageRequested(true);
                    }
                }

                locked = false;
            });
            this.getTemplateViewModel().tagLoadEnable(true);
        }
    }

    private runOnScroll(event, lastCall, locked, self, div) {

        if(locked) return;

        if (lastCall) clearTimeout(lastCall);
        lastCall = setTimeout(() => {
            if(self) {
                self.runOnScroll(event, lastCall, locked, self);
            }
        }, 200);

        locked = false;
    }

    protected onClickTag(data) {
        const typeName = data.type ? data.type.name : null;
        const datasetName = data.type && data.type.dataset ? data.type.dataset.name : null;
        const idType = data.type ? data.type.id : null;
        const optionalReferenceFields = data.type ? data.type.optionalReferenceFields : null;
        const fields = data.type ? data.type.fields : null;

        if(data.specifications && optionalReferenceFields) {

            optionalReferenceFields.forEach((optionalReferenceField) => {
                const spec = data.specifications.find(spec => spec.idField == optionalReferenceField.idField);
                if (spec) {
                    optionalReferenceField.value = spec.value;
                }
            })
        }

        const newTagType = typeName ? {
            name: typeName + ` (${datasetName})`,
            id: idType,
            typeName: typeName,
            datasetName: datasetName,
            fields: fields,
            optionalReferenceFields: optionalReferenceFields,
        } : null;

        this.getTemplateViewModel().tagName(data.name);
        this.getTemplateViewModel().tagType(newTagType);
        this.tagTypeFilter.setOption(newTagType);
        this.getTemplateViewModel().selectedTagId(data.id);
    }

    protected onClickActivateTag() {
        const selectedTagId = this.getTemplateViewModel().selectedTagId();
        this.caller.activateTag(selectedTagId);
    }

    public show(): void {

        if (!document.body.classList.contains("is-fixed")) {
            document.body.classList.add("is-fixed");
        }

        this.getTemplateViewModel().isVisible(true);
        this.resetPagination();
    }

    public hide(): void {

        document.body.classList.remove("is-fixed");
        this.getTemplateViewModel().isVisible(false);
    }

    public resetPagination() {

        this.getTemplateViewModel().pagination.pageNumber(1);
        this.getTemplateViewModel().pagination.pageMax(1);
    }

    public resetPageValues() {

        this.getTemplateViewModel().tagName('');
        this.getTemplateViewModel().selectedTagId(null);
        this.getTemplateViewModel().tagType({});
        this.tagTypeFilter.clearSelectedOption();
        this.setTags([]);
        this.resetPagination();
    }

    protected onClickCancel() {
        this.resetPageValues();
        this.hide();
    }

    public updateSelectedTagType(tagType) {
        this.getTemplateViewModel().tagType(tagType);
    }

    public openTagStore() {
        this.show();
    }

    protected similarSearchTags() {
        const tagName = this.getTemplateViewModel().tagName();

        if (tagName) {
            this.resetPagination();
            this.caller.similarSearchTags();
        } else {
            this.resetPagination();
            this.setTags([]);
            this.getTemplateViewModel().selectedTagId(null)
        }
    }

    protected onClickEditOptionalReferenceField(data) {
        this.getTemplateViewModel().editedSpec(data.id);

        if (!data.value) data.value = "";
        data.field.value = data.value;

        this.tagTypeFieldEdit.setBrandOwner(null);
        this.tagTypeFieldEdit.setTagTypeField(data.field);
        this.tagTypeFieldEdit.setTagTypeId(data.idType);
        this.tagTypeFieldEdit.setEditValueOnlyMode(true);
        this.tagTypeFieldEdit.show();
    }

    public resetEditedSpec() {
        this.getTemplateViewModel().editedSpec(null);
    }

    protected formattedOptionalReferenceFieldValues(tag) {

        if(tag && tag.type && tag.type.optionalReferenceFields) {

            const optionalReferenceFields = tag.type.optionalReferenceFields;
            if(tag.type.fields && tag.specifications) {
                const fields = tag.type.fields;
                const specifications = tag.specifications;
                var value = '';
                optionalReferenceFields.forEach((optionalReferenceField) => {
                    var foundField = fields.find(field => field.id == optionalReferenceField.idField);
                    var foundSpec = specifications.find(spec => spec.idField == optionalReferenceField.idField);
                    if(foundField && foundSpec){
                        value += foundField.label + ': ' + foundSpec.value;
                    }
                })
                return value;

            }
        }
    }

    public updateSpecification(): void {
        const specification = this.tagTypeFieldEdit.getViewModelForRequest();
        const editedSpec = this.getTemplateViewModel().editedSpec();
        let specValue = null;

        if(specification.dataType == "tags") {
            specValue = specification.originalValue.map(value => value.id).toString();
        } else {
            specValue = specification.originalValue;
        }
        const newSpecs = []

        this.getTemplateViewModel().selectedTagTypeOptionalReferenceFields().forEach((optionalReferenceField) => {
            if(optionalReferenceField.id == editedSpec) {
                if (specValue == '') {
                    specValue = null
                }
                optionalReferenceField.value = specValue;
            }

            newSpecs.push(optionalReferenceField);

        })

        this.getTemplateViewModel().selectedTagTypeOptionalReferenceFields([]);
        this.getTemplateViewModel().selectedTagTypeOptionalReferenceFields(newSpecs);
        this.getTemplateViewModel().selectedTagId(null)

        this.resetEditedSpec();
        this.tagTypeFieldEdit.getTemplateViewModel().selectedTags([]);
        this.tagTypeFieldEdit.hide();
        this.tagTypeFieldEdit.clearErrorMessages();
      }

}



// WEBPACK FOOTER //
// ./js/components/templates/tagStore_template.ts